// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 11) return "static/js/d4678687fac1b83d941a.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"224226748818e2a45403","140":"6a0abc475324d5c16276","141":"244525de64d248055a24"}[chunkId] + ".chunk.js";
};